var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.633,
    height: 15.452,
    viewBox: "0 0 21.633 15.452",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5675",
    "data-name": "Group 5675",
    transform: "translate(-616.719 -682.774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_26",
    "data-name": "Layer 26",
    transform: "translate(614.719 676.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4777",
    "data-name": "Path 4777",
    d: "M21.315,21.452h-17A2.318,2.318,0,0,1,2,19.134V8.318A2.318,2.318,0,0,1,4.318,6h17a2.318,2.318,0,0,1,2.318,2.318V19.134A2.318,2.318,0,0,1,21.315,21.452Zm-17-13.907a.773.773,0,0,0-.773.773V19.134a.773.773,0,0,0,.773.773h17a.773.773,0,0,0,.773-.773V8.318a.773.773,0,0,0-.773-.773Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5676",
    "data-name": "Group 5676",
    transform: "translate(-14.943 112.359)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5675-2",
    "data-name": "Group 5675"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19071",
    "data-name": "Path 19071",
    d: "M15.036,28.77,13.324,24.2,11.612,28.77a.834.834,0,1,1-1.563-.582l2.493-6.649a.831.831,0,0,1,1.563,0L16.6,28.188a.834.834,0,1,1-1.563.582Z",
    transform: "translate(625 552.989)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19072",
    "data-name": "Path 19072",
    d: "M15.156,27.649H11.831a.831.831,0,0,1,0-1.662h3.324a.831.831,0,0,1,0,1.662Zm5.818,1.662H19.311a.831.831,0,0,1-.831-.831V21.831A.831.831,0,0,1,19.311,21h1.662a4.156,4.156,0,0,1,0,8.311Zm-.831-1.662h.831a2.493,2.493,0,0,0,0-4.987h-.831Z",
    transform: "translate(624.83 552.987)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.9398ab2d4b2c00a435f6c04871fb79fe.svg";
export { ForwardRef as ReactComponent };